import React from "react";
import { NavLink } from "react-router-dom";
import estilo from "../styles/Generos.module.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Pagination } from "swiper";

function Generos() {
  return (
    <div className={estilo.seleccion_generos}>
      <Swiper
        slidesPerView={10}
        spaceBetween={0}
        loop={true}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 2,
          },
          420: {
            slidesPerView: 3,
          },
          578: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          960: {
            slidesPerView: 6,
          },
          1200: {
            slidesPerView: 8,
          },
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/accion"
          >
            <span className={estilo.generos}>Acción</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/animacion"
          >
            <span className={estilo.generos}>Animación</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/aventura"
          >
            <span className={estilo.generos}>Aventura</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/ciencia-ficcion"
          >
            <span className={estilo.generos}>Ciencia Ficción</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/comedia"
          >
            <span className={estilo.generos}>Comedia</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/crimen"
          >
            <span className={estilo.generos}>Crimen</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/clasicas"
          >
            <span className={estilo.generos}>Clásicas</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/drama"
          >
            <span className={estilo.generos}>Drama</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/documental"
          >
            <span className={estilo.generos}>Documental</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/familia"
          >
            <span className={estilo.generos}>Familia</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/fantasia"
          >
            <span className={estilo.generos}>Fantasía</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/historia"
          >
            <span className={estilo.generos}>Historia</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/infantil"
          >
            <span className={estilo.generos}>Infantil</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/misterio"
          >
            <span className={estilo.generos}>Misterio</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/musica"
          >
            <span className={estilo.generos}>Música</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/romance"
          >
            <span className={estilo.generos}>Romance</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/suspenso"
          >
            <span className={estilo.generos}>Suspenso</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/superheroe"
          >
            <span className={estilo.generos}>Superhéroe</span>
          </NavLink>
        </SwiperSlide>
        <SwiperSlide>
          <NavLink
            className={({ isActive }) =>
              isActive ? `${estilo.activo}` : `${estilo.no_activo}`
            }
            to="/terror"
          >
            <span className={estilo.generos}>Terror</span>
          </NavLink>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Generos;
